import { useState, useEffect } from 'react'
import QRCode from 'qrcode'

interface PrintQRCodeProps {
  value: string
  size?: string
}

export default function PrintQRCode({ value, size = '2cm' }: PrintQRCodeProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    QRCode.toDataURL(value, { width: 300, margin: 1 })
      .then(url => {
        if (!cancelled) setDataUrl(url)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [value])

  if (!dataUrl) return null

  return (
    <img
      src={dataUrl}
      alt=""
      aria-hidden="true"
      style={{ width: size, height: size, display: 'block' }}
    />
  )
}
